import * as types from './mutation-types'
import { requestUtils, formDataFactory } from '../../helpers'

const state = {
  list: []
}

const getters = {
  getGameGroups (state) {
    return state.list
  },
  getValidGameGroups (state, rootGetters) {
    const user = rootGetters.getUser
    const validStates = ['pending', 'owner', 'accepted']
    return state.list.filter((group) => {
      let player = group.players.filter(u => u.user.id === user.id)[0]
      return validStates.indexOf(player.state) > -1
    })
  }
}

const actions = {
  createGameGroup ({ commit, rootGetters }, data) {
    let formData = formDataFactory.build(data, 'game_group', 'json')
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.post('/game_groups', formData, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_NOTIFICATION, {
            type: 'success',
            message: response.message
          })
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  loadGameGroups ({ commit, state, rootGetters }) {
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.get('/game_groups', null, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_GAME_GROUPS, response.data)
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  deleteGameGroup ({ commit, rootGetters }, id) {
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.delete(`/game_groups/${id}`, null, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_NOTIFICATION, {
            type: 'success',
            message: response.message
          })
          commit(types.REMOVE_GAME_GROUP, id)
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  updateGameGroup ({ commit, rootGetters }, data) {
    let formData = formDataFactory.build(data, 'game_group', 'json')
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.put(`/game_groups/${data.id}`, formData, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_NOTIFICATION, {
            type: 'success',
            message: response.message
          })
          commit(types.UPDATE_GAME_GROUP, { id: data.id, data: response.data })
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  deleteGameGroupUser ({ commit, rootGetters }, id) {
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.delete(`/game_group_users/${id}`, null, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_NOTIFICATION, {
            type: 'success',
            message: response.message
          })
          commit(types.REMOVE_GAME_GROUP_USER, id)
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  updateGameGroupUser ({ commit, rootGetters }, data) {
    let formData = formDataFactory.build(data, 'game_group_user', 'json')
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.put(`/game_group_users/${data.id}`, formData, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_NOTIFICATION, {
            type: 'success',
            message: response.message
          })
          commit(types.UPDATE_GAME_GROUP_USER, { id: data.id, newState: data.state })
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  }
}

const mutations = {
  [types.SET_GAME_GROUPS] (state, list) {
    state.list = list
  },
  [types.UPDATE_GAME_GROUP] (state, data) {
    state.list = state.list.map((item) => {
      if (item.id === data.id) {
        item = data.data
      }
      return item
    })
  },
  [types.REMOVE_GAME_GROUP] (state, id) {
    state.list = state.list.filter((item) => {
      return item.id !== id
    })
  },
  [types.REMOVE_GAME_GROUP_USER] (state, id) {
    state.list = state.list.map((item) => {
      item.players = item.players.filter((player) => {
        return player.id !== id
      })
      return item
    })
  },
  [types.UPDATE_GAME_GROUP_USER] (state, { id, newState }) {
    state.list = state.list.map((item) => {
      item.players = item.players.map((player) => {
        if (player.id === id) {
          player.state = newState
        }
        return player
      })
      return item
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/game_group.js